import { TimePicker } from "antd";
import { Dayjs } from "dayjs";
import { IWorkTimeOfDay } from "../../../models/investor/response";
import { getDisabledRanges } from "../../../utils/helpers/format-time";

const TimePickerWithDisabledRanges = ({
  workTimeOfDay,
  onChange,
  startTime = null,  
}: {
  workTimeOfDay: IWorkTimeOfDay;
  onChange?: (time: Dayjs | null, timeString: string) => void;
  startTime?: string | null;  
}) => {
  const { disabledHours, disabledMinutes } = getDisabledRanges(
    workTimeOfDay.workTimes,
    startTime 
  );

  return (
    <TimePicker
      format="HH:mm"
      disabledTime={() => ({
        disabledHours: () => disabledHours,
        disabledMinutes,
      })}
      onChange={onChange}
    />
  );
};



export default TimePickerWithDisabledRanges;
